import { render, staticRenderFns } from "./AddIconButton.vue?vue&type=template&id=93c4dd96&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddIconButton.vue"
export default component.exports